import posthog from "posthog-js";
import { filterPostHogBrowserEvent } from "~/lib/posthog/browser-event-filter";
import { getPostHogAutocaptureUrlAllowlist } from "~/lib/posthog/config";

const isPostHogEnabled =
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_VERCEL_ENV === "production" &&
  !process.env.NEXT_PUBLIC_DEPLOYMENT_URL?.includes("localhost") &&
  process.env.NEXT_PUBLIC_POSTHOG_API_KEY &&
  process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (isPostHogEnabled) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_API_KEY!, {
    api_host: "/ingest",
    ui_host: "https://eu.posthog.com",
    defaults: "2025-05-24",
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: "identified_only",
    // Cookieless until analytics consent: anonymous events only, nothing
    // stored on the device. The provider upgrades persistence on consent.
    persistence: "memory",
    autocapture: {
      url_allowlist: getPostHogAutocaptureUrlAllowlist(),
    },
    disable_session_recording: true,
    session_recording: {
      // Device diagnostics use explicit events, not replay request payloads.
      maskCapturedNetworkRequestFn: (request) =>
        window.location.pathname === "/device-test" ||
        window.location.pathname.startsWith("/device-test/")
          ? undefined
          : request,
    },
    error_tracking: {
      captureExtensionExceptions: false,
    },
    capture_exceptions: true,
    logs: {
      captureConsoleLogs: false,
    },
    before_send: filterPostHogBrowserEvent,
  });
}
